import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  eventcustomisationglobalupdate: false,
};
export const eventCustomisationGlobalUpdateSlice = createSlice({
  name: "eventcustomisationglobalupdate",
  initialState,
  reducers: {
    seteventcustomisationglobalupdate: (state, action) => {
      state.eventcustomisationglobalupdate = action.payload;
    },
    seteventcustomisationglobalupdatelogout: (state, action) => {
      state.eventcustomisationglobalupdate = null;
    },
  },
});

export const {
  seteventcustomisationglobalupdate,
  seteventcustomisationglobalupdatelogout,
} = eventCustomisationGlobalUpdateSlice.actions;

export default eventCustomisationGlobalUpdateSlice.reducer;
